var spoiler_default = {
  "fontElementMap": "_8c-7k",
  "hideText": "BjN2f",
  "onHoverText": "imFP-",
  "hideBlock": "_44l8W",
  "smallBlur": "uvkn9",
  "mediumBlur": "P4ucy",
  "largeBlur": "uXutL",
  "hideBlock_gallery": "VBC3F",
  "overlay": "ENUOg",
  "overlay_gallery": "qsQZW",
  "revealSpoilerBtn": "rG3mM",
  "isMobile": "UYz09",
  "onHoverBtn": "wRiHI",
  "spoilerWrapper": "wy5BM",
  "spoilerDescription": "w3D7s",
  "spoilerContainer": "r-MHB",
  "spoilerContainer_Gallery": "_2kx8v"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
